import React from 'react';
import {
    Container,
    Menu,
    Image,
} from 'semantic-ui-react';

const AppHeader = props => {
    return (
        <Menu className='header'>
            <Container>
                <Image className='logo' src="/img/denisonparkinglogo.png" />
                {/* <Header as='h1' content='Parking Reservation System' /> */}
            </Container>
        </Menu>
    );
};

AppHeader.propTypes = {
    
};

export default AppHeader;